import { ComponentProps, ReactNode } from 'react';
import { Dialog as MUIDialog } from '@mui/material';
import classNames from 'classnames';
import { Actions } from 'app/agriculture/components/Actions/Actions';
import { IconButton } from 'app/agriculture/components/Button/Button';
import './Dialog.scss';

interface Props {
    icon?: ReactNode;
    title?: string;
    subtitle?: string;
    isOpen?: boolean;
    actions?: ComponentProps<typeof Actions>;
    children?: ReactNode;
    className?: string;
    disableCloseButton?: boolean;
    handleClose?: () => void;
}

export function Dialog({
    icon,
    title,
    isOpen = true,
    actions,
    children,
    className,
    disableCloseButton = false,
    handleClose,
    subtitle,
}: Props) {
    return (
        <MUIDialog
            PaperProps={{
                classes: {
                    root: classNames('AgDialog', className),
                },
            }}
            open={isOpen}
        >
            {!disableCloseButton && (
                <IconButton
                    className="AgDialog__close-button"
                    variant="outlined"
                    icon="close"
                    tooltip="Close"
                    onClick={handleClose}
                    size={16}
                />
            )}
            {title == null && subtitle == null ? null : (
                <div className="AgDialog__header">
                    {title == null ? null : (
                        <div className="AgDialog__title">
                            {icon == null ? null : <div className="AgDialog__icon">{icon}</div>}
                            <h2>{title}</h2>
                        </div>
                    )}
                    {subtitle == null ? null : <h5 className="AgDialog__subtitle">{subtitle}</h5>}
                </div>
            )}
            {children == null ? null : <div className="AgDialog__content">{children}</div>}
            {!actions ? null : <Actions {...actions} />}
        </MUIDialog>
    );
}
